(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anuncios-deslizables"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(section) {
      var track = section.querySelector('.anuncios-desl-track');
      var slides = section.querySelectorAll('.anuncios-desl-slide');
      if (!track || slides.length <= 1) return;

      var intervalo = parseInt(section.dataset.intervalo, 10) || 5;
      var pausaHover = section.dataset.pausaHover === 'true';
      var currentIndex = 0;
      var timer = null;

      function goTo(index) {
        var total = slides.length;
        currentIndex = ((index % total) + total) % total;
        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      }
      function next() { goTo(currentIndex + 1); }
      function prev() { goTo(currentIndex - 1); }

      function start() {
        stop();
        timer = setInterval(next, intervalo * 1000);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      var startX = 0, startY = 0, endX = 0, endY = 0, dragging = false;
      section.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        endX = startX;
        endY = startY;
        dragging = true;
        stop();
      }, { passive: true });
      section.addEventListener('touchmove', function(e) {
        if (!dragging) return;
        endX = e.touches[0].clientX;
        endY = e.touches[0].clientY;
      }, { passive: true });
      section.addEventListener('touchend', function() {
        if (!dragging) return;
        var diffX = startX - endX;
        var diffY = startY - endY;
        if (Math.abs(diffX) > 40 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX > 0) next();
          else prev();
        }
        dragging = false;
        start();
      }, { passive: true });

      if (pausaHover) {
        section.addEventListener('mouseenter', stop);
        section.addEventListener('mouseleave', start);
      }

      start();
    }
    document.querySelectorAll('.anuncios-desl').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barra-anuncio"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseFecha(str) {
      if (!str) return null;
      var iso = String(str).trim().replace(' ', 'T');
      var d = new Date(iso);
      if (isNaN(d.getTime())) return null;
      return d;
    }
    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function getEndTime(el) {
      var modo = el.dataset.modo || 'fecha';
      if (modo === 'fecha') {
        return parseFecha(el.dataset.fechaObjetivo);
      }
      var hours = parseInt(el.dataset.duracionHoras, 10) || 0;
      var minutes = parseInt(el.dataset.duracionMinutos, 10) || 0;
      var seconds = parseInt(el.dataset.duracionSegundos, 10) || 0;
      var totalSeconds = hours * 3600 + minutes * 60 + seconds;
      if (totalSeconds <= 0) return null;
      var baseKey = el.dataset.storageKey || 'barra_anuncio_default';
      var storageKey = baseKey + '_' + totalSeconds;
      try {
        var stored = window.localStorage.getItem(storageKey);
        if (stored) {
          var endTime = parseInt(stored, 10);
          if (!isNaN(endTime) && endTime > Date.now()) {
            return new Date(endTime);
          }
        }
      } catch (e) {}
      var newEnd = Date.now() + totalSeconds * 1000;
      try { window.localStorage.setItem(storageKey, String(newEnd)); } catch (e) {}
      return new Date(newEnd);
    }
    function updateTemporizador(el) {
      var target = getEndTime(el);
      if (!target) return;
      var now = new Date();
      var diff = target.getTime() - now.getTime();
      if (diff <= 0) {
        if (el.dataset.modo === 'fecha') {
          if (!el.classList.contains('barra-tmp-finalizado')) {
            el.textContent = el.dataset.textoFinalizado || '';
            el.classList.add('barra-tmp-finalizado');
          }
          return;
        }
        diff = 0;
      }
      var dShow = el.dataset.mostrarDias === 'true';
      var hShow = el.dataset.mostrarHoras === 'true';
      var mShow = el.dataset.mostrarMinutos === 'true';
      var sShow = el.dataset.mostrarSegundos === 'true';
      var remaining = Math.floor(diff / 1000);
      var days = 0, hours = 0, minutes = 0, seconds = 0;
      if (dShow) { days = Math.floor(remaining / 86400); remaining %= 86400; }
      if (hShow) { hours = Math.floor(remaining / 3600); remaining %= 3600; }
      if (mShow) { minutes = Math.floor(remaining / 60); remaining %= 60; }
      if (sShow) { seconds = remaining; }
      var dEl = el.querySelector('.barra-tmp-dias');
      var hEl = el.querySelector('.barra-tmp-horas');
      var mEl = el.querySelector('.barra-tmp-minutos');
      var sEl = el.querySelector('.barra-tmp-segundos');
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(minutes);
      if (sEl) sEl.textContent = pad(seconds);
    }
    function tick() {
      var els = document.querySelectorAll('.barra-anuncio-temporizador');
      Array.prototype.forEach.call(els, updateTemporizador);
    }
    var intervalo = null;
    function start() {
      tick();
      if (intervalo) clearInterval(intervalo);
      intervalo = setInterval(tick, 1000);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-clientes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initResenasCarrusel(carrusel) {
    if (!carrusel || carrusel.dataset.resenasInit === 'true') return;
    carrusel.dataset.resenasInit = 'true';

    var wrapper = carrusel.parentElement;
    var btnPrev = wrapper.querySelector('[data-resenas-prev]');
    var btnNext = wrapper.querySelector('[data-resenas-next]');
    var blocksCount = parseInt(carrusel.dataset.resenasBlocksCount, 10) || 0;
    var allCards = carrusel.querySelectorAll('.resenas-card');
    var hasInfinite = blocksCount > 0 && allCards.length === blocksCount * 3;

    function getStep() {
      var card = carrusel.querySelector('.resenas-card');
      if (!card) return carrusel.clientWidth;
      var styles = window.getComputedStyle(carrusel);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function getSnapScroll(card) {
      var cardStyles = window.getComputedStyle(card);
      var snapAlign = cardStyles.scrollSnapAlign || '';
      if (snapAlign.indexOf('center') >= 0) {
        return card.offsetLeft - (carrusel.clientWidth - card.offsetWidth) / 2;
      }
      return card.offsetLeft;
    }

    function jumpInstant(scrollLeft) {
      carrusel.style.scrollBehavior = 'auto';
      carrusel.scrollLeft = scrollLeft;
      requestAnimationFrame(function () {
        carrusel.style.scrollBehavior = '';
      });
    }

    function scrollPrev() {
      carrusel.scrollBy({ left: -getStep(), behavior: 'smooth' });
    }

    function scrollNext() {
      carrusel.scrollBy({ left: getStep(), behavior: 'smooth' });
    }

    if (btnPrev) btnPrev.addEventListener('click', scrollPrev);
    if (btnNext) btnNext.addEventListener('click', scrollNext);

    var isJumping = false;
    var scrollTimer;

    function initPosition() {
      if (!hasInfinite) return;
      var firstOrig = allCards[blocksCount];
      if (firstOrig) {
        jumpInstant(getSnapScroll(firstOrig));
      }
    }

    function checkBoundaries() {
      if (!hasInfinite || isJumping) return;
      var firstOrig = allCards[blocksCount];
      var lastOrig = allCards[blocksCount * 2 - 1];
      if (!firstOrig || !lastOrig) return;

      var step = getStep();
      var setWidth = blocksCount * step;
      var current = carrusel.scrollLeft;
      var minScroll = getSnapScroll(firstOrig);
      var maxScroll = getSnapScroll(lastOrig);

      if (current < minScroll - 5) {
        isJumping = true;
        clearTimeout(scrollTimer);
        jumpInstant(current + setWidth);
        setTimeout(function () { isJumping = false; }, 80);
      } else if (current > maxScroll + 5) {
        isJumping = true;
        clearTimeout(scrollTimer);
        jumpInstant(current - setWidth);
        setTimeout(function () { isJumping = false; }, 80);
      }
    }

    if (hasInfinite) {
      carrusel.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(checkBoundaries, 120);
      });

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initPosition, 200);
      });

      requestAnimationFrame(function () {
        requestAnimationFrame(initPosition);
      });
    }

    var autoplay = carrusel.dataset.autoplay === 'true';
    var speed = parseInt(carrusel.dataset.autoplaySpeed, 10) || 5000;
    var autoplayInterval = null;

    function startAutoplay() {
      if (!autoplay || autoplayInterval) return;
      autoplayInterval = setInterval(scrollNext, speed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    if (autoplay) {
      startAutoplay();
      wrapper.addEventListener('mouseenter', stopAutoplay);
      wrapper.addEventListener('mouseleave', startAutoplay);
      wrapper.addEventListener('touchstart', stopAutoplay, { passive: true });
      wrapper.addEventListener('focusin', stopAutoplay);
    }
  }

  function initAllResenas(root) {
    var scope = root || document;
    var carruseles = scope.querySelectorAll('[data-resenas-carrusel]');
    Array.prototype.forEach.call(carruseles, initResenasCarrusel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllResenas(); });
  } else {
    initAllResenas();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAllResenas(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-trustpilot"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTpCarrusel(carrusel) {
      if (!carrusel || carrusel.dataset.tpInit === 'true') return;
      carrusel.dataset.tpInit = 'true';

      var wrapper = carrusel.parentElement;
      var btnPrev = wrapper.querySelector('[data-resenas-tp-prev]');
      var btnNext = wrapper.querySelector('[data-resenas-tp-next]');
      var blocksCount = parseInt(carrusel.dataset.resenasTpBlocksCount, 10) || 0;
      var allCards = carrusel.querySelectorAll('.resenas-tp-card');
      var hasInfinite = blocksCount > 0 && allCards.length === blocksCount * 3;

      function getStep() {
        var card = carrusel.querySelector('.resenas-tp-card');
        if (!card) return carrusel.clientWidth;
        var styles = window.getComputedStyle(carrusel);
        var gap = parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function getSnapScroll(card) {
        var cs = window.getComputedStyle(card);
        var align = cs.scrollSnapAlign || '';
        if (align.indexOf('center') >= 0) {
          return card.offsetLeft - (carrusel.clientWidth - card.offsetWidth) / 2;
        }
        return card.offsetLeft;
      }

      function jumpInstant(left) {
        carrusel.style.scrollBehavior = 'auto';
        carrusel.scrollLeft = left;
        requestAnimationFrame(function () { carrusel.style.scrollBehavior = ''; });
      }

      function scrollPrev() { carrusel.scrollBy({ left: -getStep(), behavior: 'smooth' }); }
      function scrollNext() { carrusel.scrollBy({ left: getStep(), behavior: 'smooth' }); }

      if (btnPrev) btnPrev.addEventListener('click', scrollPrev);
      if (btnNext) btnNext.addEventListener('click', scrollNext);

      var isJumping = false;
      var scrollTimer;

      function initPosition() {
        if (!hasInfinite) return;
        var firstOrig = allCards[blocksCount];
        if (firstOrig) jumpInstant(getSnapScroll(firstOrig));
      }

      function checkBoundaries() {
        if (!hasInfinite || isJumping) return;
        var firstOrig = allCards[blocksCount];
        var lastOrig = allCards[blocksCount * 2 - 1];
        if (!firstOrig || !lastOrig) return;
        var step = getStep();
        var setWidth = blocksCount * step;
        var current = carrusel.scrollLeft;
        var minScroll = getSnapScroll(firstOrig);
        var maxScroll = getSnapScroll(lastOrig);
        if (current < minScroll - 5) {
          isJumping = true;
          clearTimeout(scrollTimer);
          jumpInstant(current + setWidth);
          setTimeout(function () { isJumping = false; }, 80);
        } else if (current > maxScroll + 5) {
          isJumping = true;
          clearTimeout(scrollTimer);
          jumpInstant(current - setWidth);
          setTimeout(function () { isJumping = false; }, 80);
        }
      }

      if (hasInfinite) {
        carrusel.addEventListener('scroll', function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(checkBoundaries, 120);
        });
        var resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(initPosition, 200);
        });
        requestAnimationFrame(function () { requestAnimationFrame(initPosition); });
      }

      var autoplay = carrusel.dataset.autoplay === 'true';
      var speed = parseInt(carrusel.dataset.autoplaySpeed, 10) || 5000;
      var autoplayInterval = null;

      function startAutoplay() {
        if (!autoplay || autoplayInterval) return;
        autoplayInterval = setInterval(scrollNext, speed);
      }
      function stopAutoplay() {
        if (autoplayInterval) { clearInterval(autoplayInterval); autoplayInterval = null; }
      }
      if (autoplay) {
        startAutoplay();
        wrapper.addEventListener('mouseenter', stopAutoplay);
        wrapper.addEventListener('mouseleave', startAutoplay);
        wrapper.addEventListener('touchstart', stopAutoplay, { passive: true });
        wrapper.addEventListener('focusin', stopAutoplay);
      }
    }

    function initAllTp(root) {
      var scope = root || document;
      var carruseles = scope.querySelectorAll('[data-resenas-tp-carrusel]');
      Array.prototype.forEach.call(carruseles, initTpCarrusel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAllTp(); });
    } else {
      initAllTp();
    }

    document.addEventListener('shopify:section:load', function (e) { initAllTp(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
